import { render, staticRenderFns } from "./DocumentCalculator.vue?vue&type=template&id=e8f281da&scoped=true"
import script from "./DocumentCalculator.vue?vue&type=script&lang=js"
export * from "./DocumentCalculator.vue?vue&type=script&lang=js"
import style0 from "./DocumentCalculator.vue?vue&type=style&index=0&id=e8f281da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f281da",
  null
  
)

export default component.exports